import styled from '@emotion/styled'

export const Container = styled.div`
  align-items: center;
  background-color: #ecebeb;
  justify-content: center;
  display: flex;
  padding: 3rem 0;
  width: 100%;
`
